import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";

function filterKeystrokes(val) {
  let out = "";
  let hasDot = false;
  for (const ch of val) {
    if (ch >= "0" && ch <= "9") { out += ch; continue; }
    if (ch === "." && !hasDot) { out += ch; hasDot = true; continue; }
    if (ch === ",") { out += ch; continue; }
  }
  return out;
}

function parseCents(raw) {
  if (!raw) return null;
  const cleaned = raw.replace(/,/g, "");
  const num = parseFloat(cleaned);
  if (!Number.isFinite(num)) return null;
  return Math.round(num * 100);
}

function formatDisplay(cents) {
  if (cents === null || cents === undefined) return "";
  return (cents / 100).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export default function MoneyInput({ value, onChange, placeholder, id, className }) {
  const [raw, setRaw] = useState(() => formatDisplay(value));
  const [touched, setTouched] = useState(false);

  const display = touched ? raw : formatDisplay(value);

  const handleChange = useCallback((e) => {
    const filtered = filterKeystrokes(e.target.value);
    setRaw(filtered);
    setTouched(true);
    // Report as you type, so a Save clicked straight from the field sees the
    // new price. Blur only tidies the display.
    const cents = parseCents(filtered);
    if (cents !== (value ?? null)) onChange?.(cents);
  }, [value, onChange]);

  const handleBlur = useCallback(() => {
    if (!touched) return;
    const cents = parseCents(raw);
    setRaw(cents !== null ? formatDisplay(cents) : "");
    setTouched(false);
    if (cents !== (value ?? null)) onChange?.(cents);
  }, [raw, touched, value, onChange]);

  return (
    <input
      id={id}
      type="text"
      inputMode="decimal"
      autoComplete="off"
      className={`${styles.input}${className ? " " + className : ""}`}
      placeholder={placeholder}
      value={display}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
}

MoneyInput.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
};
